<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}条码
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="(barcodeSave && formData.id == null) || (barcodeEdit && formData.id != null)"
                     @click="saveData">保存</el-button>
        </div>
      </div>
      <div>
        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  条码/序列号
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.barcode" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  创建方式
                </th>
                <td>
                  <el-select v-model="formData.createType">
                    <el-option label="接口" :value="0"/>
                    <el-option label="手动录入" :value="1"/>
                    <el-option label="批量导入" :value="2"/>
                    <el-option label="百得导入" :value="3"/>
                  </el-select>
                </td>
                <th>
                  <em class="f-red">*</em>
                  条码类型
                </th>
                <td>
                  <el-select v-model="formData.businessType">
                    <el-option label="普通条码" :value="1"/>
                    <el-option label="工程机条码" :value="2"/>
                    <el-option label="虚拟条码" :value="3"/>
                  </el-select>
                </td>
                <th>
                  是否结算
                </th>
                <td>
                  <el-select v-model="formData.isSettle">
                    <el-option label="否" :value="0"/>
                    <el-option label="是" :value="1"/>
                  </el-select>
                </td>
              </tr>
              <tr>
                <th>
                  出入库类型
                </th>
                <td>
                  <el-select v-model="formData.barcodeType">
                    <el-option label="出库" :value="1"/>
                    <el-option label="入库" :value="2"/>
                  </el-select>
                </td>
                <th>
                  <em class="f-red">*</em>
                  产品编号
                </th>
                <td>
                  <el-input type="text"
                            autocomplete="off"
                            v-model="formData.itemCode"
                            @focus="showItemPop=true"
                            :clearable="true"
                            @clear="() => {formData.itemName = null,formData.bigCategoryId = null}"
                  >
                    <i slot="suffix" class="el-input__icon el-icon-search"
                       @click="showItemPop=true"></i>
                  </el-input>
<!--                  <el-input type="text" autocomplete="off" v-model="formData.itemCode" clearable/>-->
                </td>
                <th>
                  产品名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" :disabled="true" v-model="formData.itemName" clearable/>
                </td>
                <th>
                  产品大类
                </th>
                <td>
                  <el-select v-model="formData.bigCategoryId" style="width:9vw;" clearable>
                    <el-option v-for="item in bigCategoryOption" :key="item.categoryName"
                               :label="item.categoryName" :value="item.id" />
                  </el-select>
                </td>
              </tr>
              <tr>
                <th>
                  基本保修期(按月)
                </th>
                <td>
                  <el-input type="number" min="0" autocomplete="off" v-model="formData.guaranteePeriodMonths"
                            clearable/>
                </td>

                <th>
                  保修开始时间
                </th>
                <td>
                  <el-date-picker type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                  v-model="formData.guaranteeBeginDate" clearable/>
                </td>
                <th>
                  保修结束时间
                </th>
                <td>
                  <el-date-picker type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                  v-model="formData.guaranteeEndDate" @change="compareDate()" clearable/>
                </td>
                <th>
                  单据日期
                </th>
                <td>
                  <el-date-picker type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                  v-model="formData.billDate" clearable/>
                </td>
              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="d-item">
            <div class="title first"><b>补充信息</b></div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  单据编号
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.billNo" clearable/>
                </td>
                <th>
                  购买渠道名称
                </th>
                <td>
                  <buy-channel-name-select :buy-channel-name.sync="formData.buyChannelName"/>
                </td>
<!--                <td>-->
<!--                  <el-input type="text" autocomplete="off" v-model="formData.buyChannelName" clearable/>-->
<!--                </td>-->
                <th>
                  销售区域编码
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.saleOrgCode" clearable/>
                </td>
                <th>
                  销售区域名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.saleOrgName" clearable/>
                </td>
              </tr>
              <tr>
                <th>
                  经销商名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.unitName" clearable/>
                </td>
                <th>
                  经销商编号
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.unitCode" clearable/>
                </td>
                <th>
                  经销商地址
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.unitAddress" clearable/>
                </td>
                <th>
                  生产日期
                </th>
                <td>
                  <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="formData.productDate"
                                  type="date" placeholder="选择日期"></el-date-picker>
                </td>

              </tr>
              <tr>
                <th>
                  出库仓库编号
                </th>
                <td>
                  <el-input type="text"
                            autocomplete="off"
                            v-model="formData.warehouseCode"
                            @focus="showOutWarehouse=true"
                            :clearable="true"
                            @clear="() => {formData.warehouseName = null}"
                  >
                    <i slot="suffix" class="el-input__icon el-icon-search"
                       @click="showOutWarehouse=true"></i>
                  </el-input>
                  <!--                  <el-input type="text" autocomplete="off" v-model="formData.warehouseCode" clearable/>-->
                </td>
                <th>
                  出库仓库名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" :disabled="true" v-model="formData.warehouseName" clearable/>
                </td>
                <th>
                  入库仓库编号
                </th>
                <td>
                  <el-input type="text"
                            autocomplete="off"
                            v-model="formData.inWarehouseCode"
                            @focus="showInWarehouse=true"
                            :clearable="true"
                            @clear="() => {formData.inWarehouseName = null}"
                  >
                    <i slot="suffix" class="el-input__icon el-icon-search"
                       @click="showInWarehouse=true"></i>
                  </el-input>
<!--                  <el-input type="text" autocomplete="off" v-model="formData.inWarehouseCode" clearable/>-->
                </td>
                <th>
                  入库仓库名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" :disabled="true" v-model="formData.inWarehouseName" clearable/>
                </td>
              </tr>
              <tr>
                <th>省</th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.province" clearable/>
                </td>

                <th>市</th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.city" clearable/>
                </td>

                <th>区</th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.county" clearable/>
                </td>
                <!--                <th>-->
                <!--                  省市区-->
                <!--                </th>-->
                <!--                <td>-->
                <!--                  <el-form-item>-->
                <!--                    &lt;!&ndash; 三联地区选择 &ndash;&gt;-->
                <!--                    <template>-->
                <!--                      <Area ref="area" :maximumLevel="areaLevel" @areaNameChange="areaNameChangeHandler"-->
                <!--                            @areaObjChange="areaObjChangeHandler"/>-->
                <!--                    </template>-->
                <!--                  </el-form-item>-->
                <!--                </td>-->
              </tr>
              </tbody>
            </table>
          </div>

          <div v-if="formData.businessType == 2" class="d-item">
            <div class="title first"><b>工程信息</b></div>
              <table class="table-detail">
                <tbody>
                  <tr>
                    <th>
                      项目编号
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.projectCode" clearable/>
                    </td>
                    <th>
                      项目名称
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.projectName" clearable/>
                    </td>

                    <th>
                      工程状态
                    </th>
                    <td>
                      <el-select v-model="formData.projectStat">
                        <el-option label="已创建" :value="0"/>
                        <el-option label="进行中" :value="1"/>
                        <el-option label="已验收" :value="2"/>
                      </el-select>
                    </td>

                    <th>
                      项目产品总数
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.projectItemQty" clearable/>
                    </td>
                  </tr>
                  <tr>

                    <th>
                      项目创建日期
                    </th>
                    <td>
                      <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="formData.projectCreateDate"
                                      type="date" placeholder="选择日期"></el-date-picker>
                    </td>

                    <th>
                      服务商编码
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.projectSiteCode" clearable/>
                    </td>

                    <th>
                      楼栋号
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.projectBuildingNumber" clearable/>
                    </td>

                    <th>
                      房号
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.projectRoomNumber" clearable/>
                    </td>
                  </tr>

                  <tr>
                    <th>
                      师傅工号
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.projectEngineerCode" clearable/>
                    </td>

                    <th>
                      师傅姓名
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.projectEngineerName" clearable/>
                    </td>

                    <th>
                      师傅电话
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.projectEngineerMobile" clearable/>
                    </td>
                  </tr>
                </tbody>
              </table>
          </div>

        </div>

      </div>
    </el-form>

    <item-dialog :visiable.sync="showItemPop"
                 v-if="showItemPop"
                 @commitSelectedRow="commitSelectedRow"
                 multi="true"
                 :param="{indexNum: null, partsCode: formData.partsCode}"
    />

    <warehouse-pop :visiable.sync="showOutWarehouse"
                   :param="{excludeWarehouseType: [3], dontSite: true}"
                   v-if="showOutWarehouse"
                   @commit="outWarehouseCommitSelectedRow"
    />

    <warehouse-pop :visiable.sync="showInWarehouse"
                   :param="{excludeWarehouseType: [3], dontSite: true}"
                   v-if="showInWarehouse"
                   @commit="inWarehouseCommitSelectedRow"
    />

  </div>
</template>
<script>
import Tinymce from '@/components/Tinymce';
import {editPageMixins} from "@/mixins/tabChang"
import {mapGetters} from "vuex";
import itemDialog from "@/views/dialogCommon/itemDialog.vue";
import warehousePop from '@/views/dialogCommon/radioWarehouseDialog.vue'
import BuyChannelSelect from "@/components/formItem/buyChannelSelect.vue";
import BuyChannelNameSelect from "@/components/formItem/buyChannelNameSelect.vue";
import api from "@/api/projectApi";
import store from "@/store";

export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    BuyChannelNameSelect,
    BuyChannelSelect,
    itemDialog,
    Tinymce, warehousePop
  },
  watch: {

  },
  data() {
    return {
      barcodeSave: false,
      barcodeEdit: false,

      showItemPop: false,
      showOutWarehouse: false,
      showInWarehouse: false,

      isEdit: false,
      dataId: 0,
      getDataUrl: '/basic/basCompanyBarcode/getById',
      updateDataUrl: '/basic/basCompanyBarcode/update',
      saveDataUrl: '/basic/basCompanyBarcode/add',
      areaName: [],
      areaLevel: 4,
      bigCategoryOption: [],
      formData: {
        id: null,
        createBy: '',
        createTime: '',
        barcode: '',  // 条码/序列号,同厂商下惟一
        createType: 1 ,
        businessType: 1,
        barcodeType: 1,  // 出入库类型:1出库、2入库
        isSettle: 1,
        billDate: '',  // 单据日期
        itemCode: '',  // 产品编号
        itemName: '',  // 产品名称
        bigCategoryId: '', //产品大类
        guaranteePeriodMonths: 0,
        billNo: '',  // 单据编号
        buyChannelName: null, // 购买渠道名称
        unitCode: '',  // 经销商编号
        unitName: '',  // 经销商名称
        unitAddress: '',  // 经销商地址
        warehouseCode: '',  // 出库仓库编号
        warehouseName: '',  // 出库仓库名称
        productDate: '',  // 生产日期
        saleOrgCode: '',  // 销售区域编码
        saleOrgName: '',  // 销售区域名称
        province: '',  // 省
        city: '',  // 市
        county: '',  // 区
        inWarehouseCode: '',  // 入库仓库编号
        inWarehouseName: '',  // 入库仓库名称
        areaId: '',
        guaranteeBeginDate: null,
        guaranteeEndDate: null,
      },

      rules: {
        barcode: [{prop: '条码/序列号,同厂商下惟一', required: true, type: 'string', }],
        createType: [{prop: '创建方式', required: true, type: 'number', }],
        businessType: [{prop: '条码类型', required: true, type: 'number',}],
        barcodeType: [{prop: '出入库类型', required: false, type: 'number', }],
        isSettle: [{prop: '是否结算:0否1是', required: false, type: 'number',}],
        billDate: [{prop: '单据日期', required: false,}],
        itemCode: [{prop: '产品编号', required: true, type: 'string',}],
        itemName: [{prop: '产品名称', required: false, type: 'string',}],
        guaranteePeriodMonths: [{prop: '基本保修期(按月)', required: false, type: 'number',}],
        billNo: [{prop: '单据编号', required: false, type: 'string',}],
        buyChannelName: [{prop: '购买渠道名称', required: false, type: 'string', }],
        unitCode: [{prop: '经销商编号', required: false, type: 'string', }],
        unitName: [{prop: '经销商名称', required: false, type: 'string', }],
        unitAddress: [{prop: '经销商地址', required: false, type: 'string', }],
        warehouseCode: [{prop: '出库仓库编号', required: false, type: 'string', }],
        warehouseName: [{prop: '出库仓库名称', required: false, type: 'string', }],
        productDate: [{prop: '生产日期', required: false,}],
        saleOrgCode: [{prop: '销售区域编码', required: false, type: 'string', }],
        saleOrgName: [{prop: '销售区域名称', required: false, type: 'string',}],
        province: [{prop: '省', required: false, type: 'string', }],
        city: [{prop: '市', required: false, type: 'string',}],
        county: [{prop: '区', required: false, type: 'string'}],
        inWarehouseCode: [{prop: '入库仓库编号', required: false, type: 'string',}],
        inWarehouseName: [{prop: '入库仓库名称', required: false, type: 'string',}],
      }
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },

  created() {
    this.barcodeSave = this.permissions['barcode_add']
    this.barcodeEdit = this.permissions['barcode_edit']
    if (this._dataId && !isNaN(this._dataId)) {
      this.dataId = this._dataId;
    }
  },
  mounted() {
    this.loadbigCategoryOptions();
    this.getData();
  },
  methods: {
    //加载产品大类
    loadbigCategoryOptions() {
      this.$http({
        url: api.basItemCategory.getBigItemCategory,
        method: 'get',
        params: {
          companyId : store.getters.userInfo.tenantId
        }
      }).then(res => {
        this.bigCategoryOption = res.data.data
        console.log("bigCategoryOption",this.bigCategoryOption)
      })
    },
    commitSelectedRow(data) {
      console.log(data, '产品弹框选中')
      this.formData.itemCode = data.code
      this.formData.itemName = data.name
      this.formData.bigCategoryId = data.bigCategoryId
    },

    outWarehouseCommitSelectedRow(data) {
      this.formData.warehouseName = data.warehouseName
      this.formData.warehouseCode = data.warehouseCode
    },

    inWarehouseCommitSelectedRow(data) {
      this.formData.inWarehouseName = data.warehouseName
      this.formData.inWarehouseCode = data.warehouseCode
    },

    areaNameChangeHandler(val) {
      console.log('handler', val)
      this.formData.areaId = val
    },

    areaObjChangeHandler(val) {
      this.formData.province = val.province !== undefined ? val.province : ''
      this.formData.city = val.city !== undefined ? val.city : ''
      this.formData.county = val.county !== undefined ? val.county : ''
      this.formData.town = val.town !== undefined ? val.town : ''
    },


    createAreaNamePath() {
      let temp = ''
      if (this.formData.province != null && this.formData.province != '' && this.formData.province != undefined) {
        temp += this.formData.province
        if (this.formData.city != null && this.formData.city != '' && this.formData.city != undefined) {
          temp = temp + '/' + this.formData.city
          if (this.formData.county != null && this.formData.county != '' && this.formData.county != undefined) {
            temp = temp + '/' + this.formData.county
          }
        }
        this.$refs.area.areaNamePath = temp
      }
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: this.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data
          this.createAreaNamePath()
        })
      }
    },
    saveData() {

      let datel = new Date(Date.parse(this.formData.guaranteeBeginDate))
      let date2 = new Date(Date.parse(this.formData.guaranteeEndDate))
      if(datel > date2){
        this.$message.error("保修开始时间不能大于结束时间");
      }
      this.$validate(this.formData, this.rules).then(() => {
        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()

          this.$http({
            url: this.isEdit ? this.updateDataUrl : this.saveDataUrl,
            method: `post`,
            data: this.formData,
            isLoading: true
          }).then(() => {
            this.$message.success("保存成功！");
            this.goBackIndex()
            this.$mask.close()

          }).catch(e => {
            console.error(e)
            this.$message.error("保存失败！");
            this.$mask.close()

          })
        })

      })
    },

    compareDate(){
      let datel = new Date(Date.parse(this.formData.guaranteeBeginDate))
      let date2 = new Date(Date.parse(this.formData.guaranteeEndDate))
      if(datel > date2){
        this.$message.error("保修开始时间不能大于结束时间");
      }
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}
</style>
